import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";
import AnchorLink from 'react-anchor-link-smooth-scroll'

function debounce(fn,delay){
  let timer = null //借助闭包
  return function() {
      if(timer){
          clearTimeout(timer) 
      }
      timer = setTimeout(fn,delay) // 简化写法
  }
}

function hexColorToRgba(hexColor, opacity) {
  if (!hexColor) {
    return hexColor
  }
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

class PipelineNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorIndex: utils.getParams('anchorIndex'),
      checkedNav: '',
      checkedTitle: '',
      navFixed: false,
      tabExpand: false,
      hideMask: true,
      navList: [],
      navListFilter: [],
      navPosition: 0,
      isAndroid: utils.isAndroid()
    };
    this.navigationContentHeight = 40; // 导航条的高度值
    this.debounceTimer = '';
    this.lastNavCompOffsetTop = 0;
    this.navPosition = 0;
    this.distance = 0;
    this.navigationTab = null;
    this.isAnchorInSwitchTab = false;
    this.t1 = 0;
    this.t2 = 0;
    this.scrollTimer = null;
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll',(e)=>{
        this.handleBodyScroll();
        // this.isScrollStart();
      });
    }
  }

  componentDidMount() {
    this.isAnchorInSwitchTab = this.props['customAttributes']["data-component-belong"] === 'tab';

    const { anchorIndex = 0 } = this.state;
    let { navList = [] } = this.props;
    let checkedTitle = '', anchorComponent = null, componentId = '';
    if (!this.isAnchorInSwitchTab) {
      const navListFilter = [];
      navList.forEach(item => {
        const findItem = navListFilter.find(value => value.title === item.title);
        if (!findItem) {
          navListFilter.push(item);
        }
      });
      if (anchorIndex) {
        checkedTitle = navList[anchorIndex] && navList[anchorIndex].title;
        anchorComponent = navListFilter.find((item, index) => index == anchorIndex);
        componentId = anchorComponent && anchorComponent.id;
      } else {
        checkedTitle = navList[0] && navList[0].title;
      }
      this.setState({
        navList,
        navListFilter,
        checkedTitle
      }, () => {
        if (componentId) {
          setTimeout(() => {
            const navigationBarHeight = window.navigationBarHeight > 0 ? this.props.navigationBarHeight : this.props.navigationBarHeight;
            const scrollTo = document.querySelector(`#${componentId}`).offsetTop - (this.navigationContentHeight) - navigationBarHeight;
            window.scrollTo({
              top: scrollTo,
              behavior: "smooth"
            })
          }, 600)
        }
      })
    } else {
      const targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
      const currentNavList = [], navListFilter = [];
      if (targetTabContainer) {
        const productComList = targetTabContainer.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3') || [];
        for (let i = 0;i < productComList.length; i += 1) {
          const findItem = navList.find(item => item.id === productComList[i].getAttribute('id'));
          if (findItem) {
            currentNavList.push({
              id: findItem.id,
              title: findItem.title
            });
          }
        }
        currentNavList.forEach(item => {
          const findItem = navListFilter.find(value => value.title === item.title);
          if (!findItem) {
            navListFilter.push(item);
          }
        });
        this.setState({
          navList: currentNavList,
          navListFilter: navListFilter,
          checkedTitle: navList[0] && navList[0].title
        })
      }
    }

    document.querySelector('.nav-mask').addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false)
  }

  componentWillReceiveProps(nextProps) {
    if (this.isAnchorInSwitchTab && (nextProps.tabActive != nextProps.tabIndex)) {
      this.navigationContainerStatic && this.navigationContainerStatic.scroll({
        top: 0,
        left: 0,
      });
      this.navigationContainerFixed && this.navigationContainerFixed.scroll({
        top: 0,
        left: 0,
      });
      this.setState({
        checkedNav: '',
        checkedTitle: '',
      });
    }
    if (this.isAnchorInSwitchTab && !nextProps.tabFixed && this.state.navFixed) {
      this.setState({
        navFixed: false
      });
    }
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
     clearTimeout(this.debounceTimer);
     this.debounceTimer = null; 
    }
  }

  isScrollStart = () => {
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(this.isScrollEnd, 200);
    this.t1 = document.documentElement.scrollTop || document.body.scrollTop;
  }

  isScrollEnd = () => {
    this.t2 = document.documentElement.scrollTop || document.body.scrollTop;
    if(this.t2 == this.t1){
      console.log('滚动结束了')
      this.updateNavPostion(this.checkedNav, this.checkedTitle);
    }
  }

  handleBodyScroll = () => {
    if (this.props.tabActive != this.props.tabIndex) {
      console.log('当前锚点Tab组件所在切换Tab为被选中，阻止监听')
      return;
    }
    if (!this.navigationTab) {
      return 
    }
    if (!this.state.navList || this.state.navList.length <= 0) {
      return;
    }
    if (!this.state.tabExpand) {
      this.navigationContentHeight = this.navigationTab.clientHeight;
    }
    const navigationBarHeight = window.navigationBarHeight > 0 ? this.props.navigationBarHeight : this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    let navClientHeight = 0;
    let navOffsetTop = 0;

    let navFixed = false;
    let { navList = [] } = this.state;

    let productComList = [];
    let productComNotInTabList = [];
    let checkedNav = '', checkedIndex = 0, checkedTitle = '';

    if (!this.isAnchorInSwitchTab) {
      // 锚点Tab不被切换Tab所包含
      navClientHeight = this.navigationStaticRef.clientHeight;
      navOffsetTop = this.navigationStaticRef.offsetTop - navigationBarHeight;
      productComList = window.document.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3') || [];
      for (let i = 0;i < productComList.length; i += 1) {
        if (productComList[i].getAttribute('data-component-belong')) {
          // 如果当前组件属于Tab组件的子组件，则跳过，继续往下遍历
          continue;
        }
        if (productComList[i].getAttribute('data-component-name') === 'pipeline-imgHotMap' && productComList[i].getAttribute('class').indexOf('fixed') >= 0) {
          // 如果当前组件是热区组件，且是底部浮层展示，则跳过，继续往下遍历
          continue;
        }
        const findItem = navList.find(item => item.id === productComList[i].getAttribute('id'))
        if (findItem) {
          // 获取加入到锚点Tab中的所有组件
          productComNotInTabList.push(productComList[i]);
        }
        // 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 this.navigationContentHeight
        if ((scrollHeight + this.navigationContentHeight + navigationBarHeight + 1) >= productComList[i].offsetTop) {
          checkedNav = productComList[i].getAttribute('id');
          checkedTitle = productComList[i].getAttribute('name');
          checkedIndex = i;
        }
        if (!checkedTitle) {
          checkedTitle = navList[0] && navList[0].title
        }
      }
    } else {
      // 切换Tab包含锚点Tab
      let targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
      navClientHeight = targetTabContainer.querySelector('.navigation-container-static-wrap').clientHeight;
      navOffsetTop = targetTabContainer && targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop - navigationBarHeight;
      productComList = targetTabContainer && targetTabContainer.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3') || [];
      for (let i = 0;i < productComList.length; i += 1) {
        if (productComList[i].getAttribute('data-component-name') === 'pipeline-imgHotMap' && productComList[i].getAttribute('class').indexOf('fixed') >= 0) {
          // 如果当前组件是热区组件，且是底部浮层展示，则跳过，继续往下遍历
          continue;
        }
        const findItem = navList.find(item => item.id === productComList[i].getAttribute('id'));
        if (findItem) {
          // 获取加入到锚点Tab中的所有组件
          productComNotInTabList.push(productComList[i]);
        }
        // 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 this.navigationContentHeight
        if ((scrollHeight + this.navigationContentHeight + navigationBarHeight + 1) >= productComList[i].offsetTop) {
          checkedNav = productComList[i].getAttribute('id');
          checkedTitle = productComList[i].getAttribute('name');
          checkedIndex = i;
        }
        if (!checkedTitle) {
          checkedTitle = navList[0] && navList[0].title
        }
      }
    }

    // 查询当前展示的商品组件
    let lastNavCompBottomOffsetTop = 0
    if (productComNotInTabList && productComNotInTabList[navList.length - 1]) {
      this.lastNavCompOffsetTop = productComNotInTabList[navList.length - 1].offsetTop;  // 锚点Tab中最后一个Tab对应组件距离页面顶部的距离
      lastNavCompBottomOffsetTop = this.lastNavCompOffsetTop + productComNotInTabList[navList.length - 1].clientHeight;
    }
    const isScrollAreaUnEnd = scrollHeight + navigationBarHeight + navClientHeight < lastNavCompBottomOffsetTop;
    if (scrollHeight - navOffsetTop >= 0) {
      if (this.state.checkedNav != navList[navList.length - 1].id || ((this.state.checkedNav == navList[navList.length - 1].id) && isScrollAreaUnEnd)) {
        navFixed = true;
        this.navPosition = 0;
      } else {
        navFixed = false;
        this.navPosition = lastNavCompBottomOffsetTop - navClientHeight - navigationBarHeight;
      }
    } else {
      navFixed = false;
      this.state.tabExpand && this.setState({
        tabExpand: false
      });
    }

    if (!this.isAnchorInSwitchTab) {
      const height = lastNavCompBottomOffsetTop - this.pipelineNavigation.offsetTop;
      const navigationTabHeight = this.navigationTab ? this.navigationTab.clientHeight : 0;
      this.pipelineNavigation.style.height = `${height}px`;
      this.pipelineNavigation.style.marginBottom = `${-(height - navigationTabHeight)}px`;
    } else {
      const tabItemHeight = document.querySelector('.tab-item-content') ? document.querySelector('.tab-item-content').clientHeight : 0;
      const tabItemOffsetTop = document.querySelector('.tab-item-content') ? document.querySelector('.tab-item-content').offsetTop : 0;
      const navigationTabHeight = this.navigationTab ? this.navigationTab.clientHeight : 0;
      const navigationTabOffsetTop = this.navigationTab ? this.navigationTab.offsetTop : 0;
      if (!navFixed && isScrollAreaUnEnd) {
        this.distance = navigationTabOffsetTop - tabItemOffsetTop;
      }
      this.pipelineNavigation.style.height = `${tabItemHeight - this.distance}px`;
      this.pipelineNavigation.style.marginBottom = `${-(tabItemHeight - this.distance - navigationTabHeight)}px`;
    }

    this.checkedNav = checkedNav;
    this.checkedTitle = checkedTitle;
    this.setState({
      navFixed,
      checkedNav,
      checkedTitle,
      checkedIndex,
      navPosition: this.navPosition
    });

    // 对导航滚动防抖
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.debounceTimer = setTimeout(() => {
      this.updateNavPostion(checkedNav, checkedTitle);
    }, 60);
    
  }

  navClick = (item, index) => {
    utils.uploadTrack(this.props, {
      sort: index
    })
    // 导航跳转
    this.setState({
      checkedNav: item.id,
      tabExpand: false,
      hideMask: true
    });
    if (typeof window !== 'undefined') {
      // window.location.href = `#${item}`;
      // 使用replace代替href跳转，避免在history中留下记录
      window.location.replace(`#${item.id}`);
    }

    setTimeout(() => {
      const navigationBarHeight = window.navigationBarHeight > 0 ? this.props.navigationBarHeight : this.props.navigationBarHeight;
      const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop) - (this.navigationContentHeight - 1) - navigationBarHeight;
      window.scrollTo(0, scrollTop);
    }, 60);
  }

  expandClick = () => {
    const navigationBarHeight = window.navigationBarHeight > 0 ? this.props.navigationBarHeight : this.props.navigationBarHeight;
    let offsetTop = 0;
    if (!this.isAnchorInSwitchTab) {
      offsetTop = window.document.querySelector('.navigation-container-static-wrap').offsetTop - navigationBarHeight;
    } else {
      const targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
      offsetTop = targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop;
    }
    !this.state.navFixed && window.scrollTo(0, offsetTop + 1);
    const tabExpand = !this.state.tabExpand
    this.setState({
      tabExpand,
      hideMask: false
    });
    setTimeout(() => {
      this.setState({
        hideMask: !tabExpand
      });
    }, 250)
  }

  updateNavPostion = (checkedNav, checkedTitle) => {
    // 导航条切换选中后，调整当前导航到居中位置
    let navigationBar, checkedNavItem, targetTabContainer;

    if (!this.isAnchorInSwitchTab) {
      navigationBar = document.querySelector('.navigation-container-fixed');
      checkedNavItem = document.querySelector(`.navigation-container-fixed a[name="${checkedTitle}"]`); // 当前选中的导航item
    } else {
      targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabIndex];
      navigationBar = targetTabContainer && targetTabContainer.querySelector('.navigation-container-fixed');
      checkedNavItem = targetTabContainer && targetTabContainer.querySelector(`.navigation-container-fixed a[name="${checkedTitle}"]`); // 当前选中的导航item
    }

    if (!checkedNav || !checkedNavItem) {
      // navigationBar.scrollTo(0, 0);
      this.scrollSmoothTo(navigationBar, 0)
      // navigationBar.scroll({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth',
      // });
      return;
    }

    const navWidth = navigationBar.offsetWidth; // 导航栏宽度
    const checkedItemOffsetLeft = checkedNavItem.offsetLeft; // 元素距离左边距离
    const checkedItemWidth = checkedNavItem.offsetWidth;
    // 需要滚动的距离
    const shouldUpdateScroll = checkedItemOffsetLeft - (navWidth / 2 - checkedItemWidth / 2) - 16;
    if (navigationBar.scrollWidth > navWidth) {
      // 如果导航条可以滚动，执行滚动操作
      // navigationBar.scrollTo(shouldUpdateScroll, 0);
      // navigationBar.scroll({
      //   top: 0,
      //   left: shouldUpdateScroll,
      //   behavior: 'smooth',
      // });
      this.scrollSmoothTo(navigationBar, shouldUpdateScroll)
    }
  }

  scrollSmoothTo = (ele, position) => {
    if (!ele) {
      return;
    }
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function(callback, element) {
        return setTimeout(callback, 17);
      };
    }
    // 当前滚动高度
    var scrollLeft = ele.scrollLeft
    // 滚动step方法
    var step = function () {
      // 距离目标滚动距离
      var distance = position - scrollLeft;
      // 目标滚动位置
      scrollLeft = scrollLeft + distance / 5;
      if (Math.abs(distance) < 1) {
        ele.scrollTo(position, 0);
      } else {
        ele.scrollTo(scrollLeft, 0);
        requestAnimationFrame(step);
      }
    };
    step();
};

  render() {
    const { baseConfig } = this.props.config;
    const { osVersion = '' } = this.props;
    const { isAndroid, navFixed, navListFilter = [], tabExpand, hideMask, navPosition } = this.state;
    const hasMore = navListFilter.length > 3;
    const navigationBarHeight = window.navigationBarHeight > 0 ? this.props.navigationBarHeight : this.props.navigationBarHeight;
    const navigationWrapperClass = 'pipeline-navigation';
    let maskClass = tabExpand ? "nav-mask show" : "nav-mask hide";
    let adaptive = {}
    let position = 'sticky';
    if (!isAndroid && (osVersion == '15.1' || osVersion == '15.2')) {
      adaptive = {
        position: navFixed ? (navPosition > 0 ? 'sticky' : 'fixed') : 'sticky',
        top: navPosition <= 0 ? navigationBarHeight - 1 : navPosition + navigationBarHeight - 1
      }
    }
    if (hideMask) {
      maskClass += ' hide-mask'
    }
    if (this.isAnchorInSwitchTab && !navFixed) {
      position = 'static'
    }
    return (
      <div
        className={navigationWrapperClass}
        {...this.props['customAttributes']}
        ref={(ref) => this.pipelineNavigation = ref}
      >

        <div className={maskClass} onTouchEnd={this.expandClick}></div>
        <div 
          ref={ref => this.navigationStaticRef = ref}
          className="navigation-container-static-wrap"
        >
        </div>
        <div
          className="navigation-container-fixed-wrap"
          ref={(ref) => this.navigationTab = ref}
          style={{
            // position: position,
            backgroundColor: this.props.backgroundColor,
            top: navPosition <= 0 ? navigationBarHeight - 1 : navPosition + navigationBarHeight - 1,
            zIndex: navPosition <= 0 ? 999 : -1,
            ...adaptive
          }}
        >
          {tabExpand 
            && <p 
                className="all-classify" 
                style={{
                  color: baseConfig.fontColor,
                  fontFamily: 'PingFangSC-Regular'
                }}>
                  全部分类
                </p>
          }
          <div ref={ref => this.navigationContainerFixed = ref}  className={`navigation-container-fixed ${tabExpand ? 'expand ' : ''}${hasMore ? 'has-more' : 'not-more'}`}>
            {navListFilter.map((item, index) => {
              if (!this.state.navFixed) {
                return (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      sort: index,
                    }))}
                    className={navListFilter.length <= 4 ? "nav-item auto-width" : "nav-item fixed-width"}
                    key={index}
                    onClick={() => this.navClick(item, index)}
                    style={{
                      color: this.state.checkedTitle === item.title ? baseConfig.fontColor : baseConfig.fontColor,
                      fontFamily: this.state.checkedTitle === item.title ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                      opacity: this.state.checkedTitle === item.title ? 1 : .7,
                      fontWeight: utils.isAndroid() ? (this.state.checkedTitle === item.title ? '500' : 'normal') : 'normal'
                    }}
                  > 
                    {item.title}
                  </div>
                )
              } else {
                return (
                  <AnchorLink
                    key={`anchorlink_${index}`}
                    offset={() => {
                      utils.uploadTrack(this.props, {
                        sort: index
                      })
                      this.setState({
                        tabExpand: false,
                        hideMask: true
                      })
                      return navigationBarHeight + this.navigationContentHeight - 1
                    }} 
                    href={`#${item.id}`}
                    name={item.title}
                    className={navListFilter.length <= 4 ? "nav-item auto-width" : "nav-item fixed-width"}
                    style={{
                      color: this.state.checkedTitle === item.title ? baseConfig.fontColor : baseConfig.fontColor,
                      fontFamily: this.state.checkedTitle === item.title ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                      opacity: this.state.checkedTitle === item.title ? 1 : .7,
                      fontWeight: utils.isAndroid() ? (this.state.checkedTitle === item.title ? '500' : 'normal') : 'normal',
                      textDecoration: 'none'
                    }}
                  >
                    {item.title}
                  </AnchorLink>
                )
              }
            })} 
          </div>
          {
            hasMore && (
              <div
                className="expand-bar" onClick={this.expandClick}
                style={{
                  backgroundImage: `linear-gradient(to right, ${hexColorToRgba(this.props.backgroundColor, 0)} 0%, ${hexColorToRgba(this.props.backgroundColor, 1)} 30%, ${hexColorToRgba(this.props.backgroundColor, 1)} 100%)`
                }}
              >
                <svg className={`arrow ${tabExpand ? 'on' : ''}`} width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="https://www.w3.org/2000/svg">
                  <g id="lego_open" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="" transform="translate(2.500000, 5.000000)" fill={baseConfig.fontColor} fillRule="nonzero">
                      <path d="M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z" id="路径"></path>
                    </g>
                  </g>
                </svg>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

PipelineNavigation.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineNavigation };
export default PipelineNavigation;



// WEBPACK FOOTER //
// ./components/pipeline-navigation/index.js